import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private queue: boolean[] = [];
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  show() {
    this.queue.push(true);
    this.loadingSubject.next(true);
  }

  hide() {
    this.queue.pop();
    if (this.queue.length === 0) {
      this.loadingSubject.next(false);
    }
  }
}